/**
 * @generated SignedSource<<2b4139ba2a5e84e281e8baac4c2843c2>>
 * @relayHash 8969de749615c03ad3aba7b5e24765e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 141984d338b94b675f3ad3b2fa902764ec3b19db660a056d31f72300998e02bc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceLength = "LONG" | "MEDIUM" | "SHORT" | "%future added value";
export type ConfluenceTone = "CONVERSATIONAL" | "PLAYFUL" | "PROFESSIONAL" | "SURPRISE" | "%future added value";
export type AudioContainerQuery$variables = {
  cloudId: string;
};
export type AudioContainerQuery$data = {
  readonly confluence_getAudioPreference: {
    readonly length: ConfluenceLength;
    readonly tone: ConfluenceTone;
  } | null | undefined;
};
export type AudioContainerQuery = {
  response: AudioContainerQuery$data;
  variables: AudioContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceAudioPreference",
    "kind": "LinkedField",
    "name": "confluence_getAudioPreference",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "tone"
      },
      {
        "kind": "ScalarField",
        "name": "length"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AudioContainerQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AudioContainerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "141984d338b94b675f3ad3b2fa902764ec3b19db660a056d31f72300998e02bc",
    "metadata": {},
    "name": "AudioContainerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1835adcc14d38c93ac6ab5bd69c3144f";

export default node;
